/**
 * Format play count dengan delimiter ribuan untuk mempermudah membaca angka
 * @param {number} count - Jumlah play count
 * @returns {string} - Formatted play count dengan delimiter
 */
export const formatPlayCount = (count) => {
  if (!count && count !== 0) return '0';
  
  const num = typeof count === 'number' ? count : parseInt(count) || 0;
  
  // Format dengan delimiter ribuan (contoh: 10,000, 100,000)
  return num.toLocaleString('id-ID');
};

